<template>
	<div class="top-navbar">
		<div class="top-navbar-content">
			<ul>
				<template v-for="(link, index) in links">
					<Link
						v-if="index != 'lang'"
						:key="index"
						:title="link.title"
						:url="link.url"
						:target="link.target"
						:className="'top-navbar'"
					/>
					<LangLink v-else :link="link" :key="index" :className="'top-navbar'" />
				</template>
			</ul>
			<ul class="social">
				<Link
					v-for="(social, index) in socials"
					:key="index"
					:title="social.title"
					:url="social.url"
					:target="social.target"
					:className="'social ' + index"
				/>
			</ul>
		</div>
	</div>
</template>
<script>
import Link from '../partials/Link.vue'
import LangLink from '../partials/LangLink.vue'
export default {
	name: 'TopNavbar',
	components: { Link, LangLink },
	computed: {
		links() {
			return this.$t('TopNavbar.links')
		},
		socials() {
			return this.$t('TopNavbar.social')
		},
	},
}
</script>
<style scoped lang="scss">
.top-navbar {
	background-color: $greenTheme;
	margin: 0 auto;
}

.top-navbar-content {
	@include flex-container(flex-end, flex-end, flex-end);
	max-width: $innerWidth;
	margin: 0 auto;
}

ul {
	@include flex-container(flex-end, center, center);
	height: 40px;

	&.social {
		margin: 0 15px;
	}
}
</style>
